export default __webpack_public_path__ + "static/media/Rakhi Israni.dd67e485.jpg";